<template>
  <div style="position:relative;padding-top:10px;background:#FFF;">
    <section>
      <Modal
        v-model="modalRefuseConfirm"
        width="400"
        :title="modalRefuseConfirm_title"
        @on-ok="modalRefuseConfirm_ok"
        @on-cancel="modalRefuseConfirm_cancel" 
        :mask-closable="false"
      >
        <slot name='body' style='text-align:center'>
          <Label>{{$t('pdca.t50')}}</Label>
        </slot>
      </Modal>
      <Modal
        v-model="modal1"
        :title="$t('pdca.t10')"
        @on-ok="ok"
        width="900"
        @on-cancel="cancel"
        :mask-closable="false"
      >
          <m-assembly-table
            :formData="formDataBadItem"
            :columns="columnsBadItem"
            :data="dataBadItem"
            :total="total"
            :settings="settings"
            :loading="loading"
            :currentPage="current"
            :pageSize="pageSize"
            :height="250"
            @onSubmit="onSubmitBadItem"
            @onPageSizeChange="onPageSizeChange"
            @onCurrentPageChange="onCurrentPageChange">
          </m-assembly-table>
          <div slot="footer"></div>
      </Modal>
        <Tabs value="tab1">
            <TabPane :label="$t('pdca.t11')" name="tab1">
              <div style="padding: 10px 20px;">
                <Form>
                  <custom-panel name="1" :gutter="false">
                      {{$t('pdca.t12')}}
                      <div slot="content">
                          <table class="form-table" cellspacing="0" cellpadding="0" border="0" width="100%">
                              <colgroup>
                                  <col width="16.6%">
                                  <col width="16.6%">
                                  <col width="16.6%">
                                  <col width="16.6%">
                                  <col width="16.6%">
                                  <col width="16.6%">
                              </colgroup>
                              <tbody>
                                  <tr>
                                      <th align="right">
                                          {{$t('pdca.t13')}}
                                      </th>
                                      <td>
                                        <FormItem>
                                          <Input type="text" disabled v-model="formData1.WF_NO"/>
                                        </FormItem>
                                      </td>
                                      <th align="right">
                                          {{$t('pdca.t14')}}
                                      </th>
                                      <td>
                                        <FormItem>
                                          <Input type="text" disabled v-model="formData1.EXAMINED_NUMBER"/>
                                        </FormItem>
                                      </td>
                                      <th align="right">
                                          {{$t('pdca.t15')}}
                                      </th>
                                      <td>
                                        <FormItem>
                                          <Input type="text" disabled v-model="formData1.WF_STATUS_TL"/>
                                        </FormItem>
                                      </td>
                                  </tr>
                                  <tr>
                                      <th align="right">
                                        {{$t('pdca.t16')}}
                                      </th>
                                      <td>
                                        <FormItem>
                                          <Input type="text" disabled v-model="formData1.PROBLEM_SOURCE_TL"/>
                                        </FormItem>
                                      </td>
                                      <th align="right">
                                          {{$t('pdca.t17')}}
                                      </th>
                                      <td>
                                        <FormItem>
                                          <Input type="text" disabled v-model="formData1.USER_CREATED_TL"/>
                                        </FormItem>
                                      </td>
                                      <th align="right">
                                        {{$t('pdca.t18')}}
                                      </th>
                                      <td>
                                        <FormItem>
                                          <Input type="text" disabled v-model="formData1.BRING_DATE_TL"/>
                                        </FormItem>
                                      </td>
                                  </tr>
                                  <tr>
                                      <th align="right">{{$t('pdca.t19')}}</th>
                                      <td>
                                      <FormItem>
                                        <Input type="text" disabled v-model="formData1.ORG_ID_TL"/>
                                      </FormItem>
                                      </td>
                                      <th align="right">{{$t('pdca.t20')}}</th>
                                      <td>
                                        <FormItem>
                                          <Input type="text" disabled v-model="formData1.SUPPLIER_SHORT_NAME"/>
                                        </FormItem>
                                      </td>
                                      <th align="right">{{$t('pdca.t21')}}</th>
                                      <td class="ellipsis">
                                        <FormItem>
                                          <Input type="text" disabled v-model="formData1.MATERIAL_BIG_CLASS"/>
                                        </FormItem>
                                      </td>
                                  </tr>
                                  <tr>
                                    <th align="right">{{$t('pdca.t22')}}</th>
                                    <td>
                                      <FormItem>
                                        <Input type="text" disabled v-model="formData1.MATERIAL_NAME"/>
                                      </FormItem>
                                    </td>
                                    <th align="right">{{$t('pdca.t23')}}</th>
                                    <td>
                                      <FormItem>
                                        <Input type="text" disabled v-model="formData1.MATERIAL_CODE"/>
                                      </FormItem>
                                    </td>
                                    <th align="right">{{$t('pdca.t24')}}</th>
                                    <td class="ellipsis">
                                      <FormItem>
                                        <Input type="text" disabled v-model="formData1.MATERIAL_DESC"/>
                                      </FormItem>
                                    </td>
                                  </tr>
                                  <tr>
                                      <th align="right">{{$t('pdca.t25')}}</th>
                                      <td>
                                        <FormItem>
                                          <Input type="text" disabled v-model="formData1.BATCH_QTY"/>
                                        </FormItem>
                                      </td>
                                      <!-- <th align="right">{{$t('pdca.t26')}}</th>
                                      <td>
                                        <FormItem>
                                          <Input type="text" disabled v-model="formData1.BATCH_QTY"/>
                                        </FormItem>
                                      </td> -->
                                      <th align="right">{{$t('pdca.t27')}}</th>
                                      <td>
                                        <FormItem>
                                          <Input type="text" disabled v-model="formData1.NG_QTY"/>
                                        </FormItem>
                                      </td>
                                      <th align="right">{{$t('pdca.t28')}}</th>
                                      <td>
                                        <FormItem>
                                          <Input type="text" disabled v-model="formData1.NG_QTY_RATE"/>
                                        </FormItem>
                                      </td>
                                  </tr>
                                  <tr>
                                      <th align="right">{{$t('pdca.t29')}}</th>
                                      <td>
                                        <FormItem>
                                          <Input type="text" disabled v-model="formData1.QTY_CHARACTERISTIC"/>
                                        </FormItem>
                                      </td>
                                      <th align="right">{{$t('pdca.t30')}}</th>
                                      <td>
                                        <FormItem>
                                          <Input type="text" disabled v-model="formData1.NG_LEVEL"/>
                                        </FormItem>
                                      </td>
                                      <th align="right">{{$t('pdca.t31')}}</th>
                                      <td>
                                        <FormItem>
                                          <Input type="text" disabled v-model="formData1.LIABILITY_ATTRIBUTION_TL"/>
                                        </FormItem>
                                      </td>
                                  </tr>
                                  <tr>
                                      <th align="right">{{$t('pdca.t32')}}</th>
                                      <td>
                                        <FormItem>
                                          <Input type="text" disabled v-model="formData1.DUTY_DEPARTMENT"/>
                                        </FormItem>
                                      </td>
                                      <th align="right">{{$t('pdca.t33')}}</th>
                                      <td>
                                        <FormItem>
                                          <Input type="text" disabled v-model="formData1.PERSON_LIABLE"/>
                                        </FormItem>
                                      </td>
                                      <th align="right">{{$t('pdca.t34')}}</th>
                                      <td>
                                        <FormItem>
                                          <Input type="text" disabled v-model="formData1.VERIFICATION_CYCLE_TL"/>
                                        </FormItem>
                                      </td>
                                  </tr>
                                  <tr>
                                      <th align="right">{{$t('pdca.t35')}}</th>
                                      <td>
                                        <FormItem>
                                          <Input type="text" disabled v-model="formData1.REPEATED_FINISH_DATE_TL"/>
                                        </FormItem>
                                      </td>
                                      <th align="right">{{$t('pdca.t36')}}</th>
                                      <td>
                                        <FormItem>
                                          <Input type="text" disabled v-model="formData1.REQESTED_FINISH_DATE_TL"/>
                                        </FormItem>
                                      </td>
                                      <td colspan="2">&nbsp;</td>
                                  </tr>
                                  <tr>
                                      <th align="right">{{$t('pdca.t37')}}</th>
                                      <td colspan="5" align="left">
                                        <FormItem>
                                          <Input type="textarea" :rows="3" disabled v-model="formData1.PROBLEM_DESC"/>
                                        </FormItem>
                                      </td>
                                  </tr>
                              </tbody>
                          </table>
                      </div>
                  </custom-panel>
                  <custom-panel name="1" style="margin-top: 20px;">
                    {{$t('pdca.t38')}}
                    <div slot="content">
                      <a v-if="formData1.PROBLEM_SOURCE === 'IncomingCPK' || formData1.PROBLEM_SOURCE === 'OutgoingCPK'" :href="GSCCPKReportUrl" target="_blank">{{GSCCPKReportUrl}}</a>
                      <ul v-if="uploadList1.length > 0" class="upload-list">
                        <li
                          v-for="file in uploadList1"
                          :key="file"
                          class="upload-list-file upload-list-file-finish">
                          <a @click.prevent="downloadUploadListFile(file.fileId)">
                            <Icon :type="format(file)"></Icon> <span>{{file.name}}</span>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </custom-panel>
                  <custom-panel name="1" style="margin-top: 20px;" :gutter="false">
                      {{$t('pdca.t39')}}
                      <div class="pull-right" style="padding: 0px 20px;"><Button v-if="!readOnly" type="primary" @click.stop="handleAdd">{{$t('pdca.t51')}}</Button></div>
                      <div slot="content">
                          <Table class="pdca-table" border :columns="columns" :data="data"></Table>
                      </div>
                  </custom-panel>
                  <custom-panel name="1" style="margin-top: 20px;">
                    {{$t('pdca.t40')}}
                    <div slot="content">
                      <br/>
                      <Upload
                        v-if="!readOnly"
                        :format="['xls','xlsx','doc','docx','jpeg','jpg','png','gif','pdf','txt','xml']"
                        :show-upload-list="false"
                        ref="appendFile_ref2"
                        :before-upload="handleBeforeUpload2"
                        :on-error="errorUpload2"
                        :on-success="successUpload2"
                        :action="uploadFileUrl"
                        :on-format-error="onFormatErrorUpload2"
                        :on-exceeded-size="onExceededSizeUpload2"
                      >
                        <Button type="ghost" icon="ios-cloud-upload-outline" style="width: 150px;">{{$t('pdca.t41')}}</Button>
                      </Upload>
                      <ul v-if="uploadList2.length > 0" class="upload-list">
                        <li
                          v-for="file in uploadList2"
                          :key="file"
                          class="upload-list-file upload-list-file-finish">
                          <a @click.prevent="downloadUploadListFile(file.fileId)">
                            <Icon :type="format(file)"></Icon> <span>{{file.name}}</span>
                          </a>
                          &nbsp;
                          <a v-if="!readOnly" @click.prevent="deleteUploadListFile('2', file.fileId)">
                            <Icon type="ios-close"></Icon>
                          </a>
                        </li>
                      </ul>
                      <br/>
                      <div v-if="this.appendFile2 !== null">
                        {{this.$t('common.file')}}: {{ this.appendFile2.name }}
                        <Button type="primary" size="small" @click="clickToUpload2"
                                :loading="this.appendFileLoadingStatus2">{{
                          this.appendFileLoadingStatus2 ? this.$t('common.uploading') :
                          this.$t('common.clickToUpload') }}
                        </Button>
                      </div>
                      <br/>
                      <span>{{$t('pdca.t42')}}</span>
                    </div>
                  </custom-panel>
                </Form>
              </div>
            </TabPane>
            <TabPane :label="$t('pdca.t43')" name="tab2">
              <custom-panel name="1" :gutter="false" style="margin:0 10px;">
                {{$t('pdca.t44')}}
                <div slot="content">
                  <Table class="pdca-table" size="small" highlight-row border :data="flowData" :columns="flowColumns">
                  </Table>
                </div>
              </custom-panel>
              <custom-panel name="1" :gutter="false" style="margin:20px 10px;">
                {{$t('pdca.t45')}}
                <div slot="content">
                  <Table class="pdca-table" size="small" highlight-row border :data="flowTab1Data" :columns="flowTab1Columns" :row-class-name="rowClassName">
                  </Table>
                </div>
              </custom-panel>
            <!-- <Tabs type="card" style="margin-top:10px;">
                <TabPane label="表格">
                </TabPane>
                <TabPane label="流转日志"></TabPane>
                <TabPane label="传阅记录"></TabPane>
            </Tabs> -->
            </TabPane>
        </Tabs>
        <div style="position:absolute;top:8px;right:5px;">
          <Button type="ghost" style="margin-left: 8px;" @click="backToPageMain">{{$t('pdca.t46')}}</Button>
          <Button v-if="!readOnly" :loading="loading" type="primary" style="margin-left: 8px;" @click="submitProcess">{{$t('pdca.t47')}}</Button>
          <Button :loading="loading" type="ghost" style="margin-left: 8px;" @click="viewShipmentInspection">{{$t('pdca.t48')}}</Button>
          <Button :loading="loading" type="ghost" style="margin-left: 8px;"  @click="badItemHistoryClick">{{$t('pdca.t49')}}</Button>
        </div>
    </section>
  </div>
</template>
<script>
    import axios from 'axios';
    import CustomPanel from '@/components/awesome/page/panel/index';
    import mAssemblyTable from '@/components/awesome/page/assembly_table/index.js';
    import moment from 'moment';
    import { qmsApiSwitch } from '@/utils/tool';
    export default {
        name: 'IncomingProcess',
        components: {
          CustomPanel,
          mAssemblyTable
        },
        props: {
            readOnly: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
              loading: false,
              rejectCount: null,
              flowTab1Columns: [
                {
                  key: 'nodeId',
                  title: this.$t('pdca.t52')
                },
                {
                  key: 'nodeName',
                  title: this.$t('pdca.t53')
                },
                {
                  key: 'handlerNames',
                  title: this.$t('pdca.t54')
                },
                {
                  key: 'processType',
                  title: this.$t('pdca.t55')
                }
              ],
              flowTab1Data: [],
              flowData: [],
              flowColumns: [
                {
                  key: 'fdHandlerTime',
                  title: this.$t('pdca.t56'),
                  render: (h, params) => {
                    return h('span', moment(params.row.fdHandlerTime).format('YYYY-MM-DD HH:mm:ss'));
                  },
                  width: 160
                },
                {
                  key: 'fdNodeName',
                  title: this.$t('pdca.t53'),
                },
                {
                  key: 'fdHandlerName',
                  title: this.$t('pdca.t57'),
                },
                {
                  key: 'fdMemo',
                  title: this.$t('pdca.t58'),
                },
                {
                  key: 'fdAuditeInfo',
                  title: this.$t('pdca.t59'),
                }
              ],
              modalRefuseConfirm: false,
              modalRefuseConfirm_title: this.$t('ShipmentInspection.modalRefuseConfirmTitle'),
              formDataBadItem: {
                row: 2,
                items: [
                  {
                    value: '',
                    field: 'itemCode',
                    disabled: true,
                    layout: {
                      span: 12,
                      offset: 0,
                      row: 1
                    },
                    options: {
                      rows: 1,
                      type: 'text'
                    },
                    style: 'width:130px;',
                    type: 'text',
                    title: this.$t('pdca.t60'),
                    validators: {
                      required: {
                        required: true,
                        message: this.$t('common.not_empty_require')
                      }
                    }
                  },
                  {
                    value: '',
                    field: 'startEndCheckDate',
                    type: 'datePicker',
                    title: this.$t('viewPdca.t50'),
                    layout: {
                      row: 1,
                      span: 12,
                      offset: 0
                    },
                    options: {
                      type: 'datetimerange',
                      format: 'yyyy-MM-dd'
                    },
                    style: 'width:190px;',
                    validators: {
                      required: {
                        required: true,
                        message: this.$t('common.not_empty_require')
                      }
                    }
                  },
                  {
                    value: '',
                    field: 'itemName',
                    disabled: true,
                    layout: {
                      span: 24,
                      offset: 0,
                      row: 2
                    },
                    options: {
                      rows: 1,
                      type: 'text'
                    },
                    style: 'width:550px;',
                    type: 'text',
                    title: this.$t('pdca.t61')
                  }
                ],
                buttons: {
                  showSubmit: true,
                  submitText: this.$t('common.queryBtn'),
                  showReset: true,
                  resetText: this.$t('common.clearBtn'),
                  showSearch: true,
                  layout: {
                    span: 24,
                    push: 8
                  }
                }
              },
              columnsBadItem: {
                showCheckbox: false,
                showButtons: true,
                columns: [{
                  title: this.$t('pdca.t62'),
                  key: 'vendorCode',
                  align: 'center',
                  width: 100
                },
                  {
                    title: this.$t('pdca.t63'),
                    key: 'number',
                    align: 'center',
                    width: 130
                  },
                  {
                    title: this.$t('pdca.t64'),
                    key: 'content',
                    align: 'center',
                    width: 280
                  },
                  /* {
                   title: '物料大类',
                   key: 'type1',
                   align: 'center',
                   width: 130
                   },
                   {
                   title: '物料中类',
                   key: 'type2',
                   align: 'center',
                   width: 160
                   }, */
                  {
                    title: this.$t('pdca.t65'),
                    key: 'type3',
                    align: 'center',
                    width: 150
                  },
                  {
                    title: this.$t('pdca.t66'),
                    key: 'date',
                    align: 'center',
                    width: 155
                  }
                ]
              },
              loading: false,
              total: 0,
              current: 1,
              pageSize: 10,
              condition: null,
              settings: {
                needPager: true,
                showElevator: true,
                showSizer: true,
                pageSizeOpts: [10, 30, 50, 80],
                needSearch: true,
                needValidation: true
              },
              dataBadItem: [],
              vendorCode: '',
              modal1: false,
              type: null,
              fdId: null,
              userName: null,
              sourceId: null,
              problemSource: null,
              formData1: {
                PDCA_ID: '',
                ID: '',
                WF_NO: '',
                EXAMINED_NUMBER: '',
                WF_STATUS_TL: '',
                PROBLEM_SOURCE_TL: '',
                USER_CREATED_TL: '',
                BRING_DATE_TL: '',
                ORG_ID: '',
                ORG_ID_TL: '',
                SUPPLIER_SHORT_NAME: '',
                MATERIAL_BIG_CLASS: '',
                MATERIAL_NAME: '',
                MATERIAL_CODE: '',
                MATERIAL_DESC: '',
                BATCH_QTY: '',
                NG_QTY_RATE: '',
                NG_QTY: '',
                QTY_CHARACTERISTIC: '',
                NG_LEVEL: '',
                LIABILITY_ATTRIBUTION_TL: '',
                DUTY_DEPARTMENT: '',
                PERSON_LIABLE: '',
                VERIFICATION_CYCLE_TL: '',
                REPEATED_FINISH_DATE_TL: '',
                REQESTED_FINISH_DATE_TL: '',
                PROBLEM_DESC: ''
              },
              downloadUploadListFileUrl: '/qms2gsc/file/download?id=',
              uploadFileUrl: '/qms2gsc/file/upload?',
              busid: '',
              appendFile1: null,
              appendFileLoadingStatus1: false,
              uploadList1: [],
              appendFile2: null,
              appendFileLoadingStatus2: false,
              uploadList2: [],
              CAUSE_ANALYSIS_store: {
                CAUSE_ANALYSIS: []
              },
              REFORM_MEASURES_store: {
                REFORM_MEASURES: []
              },
              PRO_FIN_DATE_store: {
                PRO_FIN_DATE: []
              },
              PERSON_LIABLE_store: {
                PERSON_LIABLE: []
              },
              DEPART_LIABLE_store: {
                DEPART_LIABLE: []
              },
              columns: [
                  {
                      type: 'index',
                      title: this.$t('pdca.t67'),
                      width: 80,
                      align: 'center'
                  },
                  {
                      title: this.$t('pdca.t68'),
                      render: (h, params) => {
                         if (this.readOnly) {
                            return h('span', params.row.CAUSE_ANALYSIS);
                         }
                          if (this.CAUSE_ANALYSIS_store.CAUSE_ANALYSIS.length === 0 || this.CAUSE_ANALYSIS_store.CAUSE_ANALYSIS.length === params.index) {
                            this.CAUSE_ANALYSIS_store.CAUSE_ANALYSIS.push({
                              rowIndex: params.index,
                              value: params.row.CAUSE_ANALYSIS
                            });
                          }
                          return h('div', [h('Input', {
                              props: {
                                type: 'textarea',
                                value: this.CAUSE_ANALYSIS_store.CAUSE_ANALYSIS[params.index].value,
                                readonly: false,
                                disabled: false
                              },
                              style: {
                                width: '100%',
                                padding: '5px'
                              },
                              on: {
                                input: (event) => {
                                  this.CAUSE_ANALYSIS_store.CAUSE_ANALYSIS[params.index].value = event;
                                }
                              }
                            })]);
                      },
                      key: 'CAUSE_ANALYSIS',
                      value: '',
                      minWidth: 240
                  },
                  {
                      title: this.$t('pdca.t69'),
                      render: (h, params) => {
                        if (this.readOnly) {
                            return h('span', params.row.REFORM_MEASURES);
                        }
                        if (this.REFORM_MEASURES_store.REFORM_MEASURES.length === 0 || this.REFORM_MEASURES_store.REFORM_MEASURES.length === params.index) {
                          this.REFORM_MEASURES_store.REFORM_MEASURES.push({
                            rowIndex: params.index,
                            value: params.row.REFORM_MEASURES
                          });
                        }
                        return h('div', [h('Input', {
                          props: {
                            type: 'textarea',
                            value: this.REFORM_MEASURES_store.REFORM_MEASURES[params.index].value,
                            readonly: false,
                            disabled: false
                          },
                          style: {
                            width: '200px',
                            padding: '5px'
                          },
                          on: {
                            input: (event) => {
                              this.REFORM_MEASURES_store.REFORM_MEASURES[params.index].value = event;
                            }
                          }
                        })]);
                      },
                      key: 'REFORM_MEASURES',
                      value: '',
                      width: 240
                  },
                  {
                      title: this.$t('pdca.t70'),
                      render: (h, params) => {
                        if (this.readOnly) {
                            return h('span', params.row.PRO_FIN_DATE);
                        }
                        if (this.PRO_FIN_DATE_store.PRO_FIN_DATE.length === 0 || this.PRO_FIN_DATE_store.PRO_FIN_DATE.length === params.index) {
                          this.PRO_FIN_DATE_store.PRO_FIN_DATE.push({
                            rowIndex: params.index,
                            value: params.row.PRO_FIN_DATE
                          });
                        }
                        return h('DatePicker', {
                          props: {
                            type: 'date',
                            format: 'yyyy/MM/dd',
                            value: this.PRO_FIN_DATE_store.PRO_FIN_DATE[params.index].value
                          },
                          on: {
                            'on-change': (format) => {
                              this.PRO_FIN_DATE_store.PRO_FIN_DATE[params.index].value = format;
                            }
                          },
                          style: 'width: 120px;'
                        });
                      },
                      key: 'PRO_FIN_DATE',
                      value: '',
                      width: 150
                  },
                  {
                      title: this.$t('pdca.t71'),
                      render: (h, params) => {
                        if (this.readOnly) {
                            return h('span', params.row.PERSON_LIABLE);
                        }
                        if (this.PERSON_LIABLE_store.PERSON_LIABLE.length === 0 || this.PERSON_LIABLE_store.PERSON_LIABLE.length === params.index) {
                          this.PERSON_LIABLE_store.PERSON_LIABLE.push({
                            rowIndex: params.index,
                            value: params.row.PERSON_LIABLE
                          });
                        }
                        return h('div', [h('Input', {
                          props: {
                            value: this.PERSON_LIABLE_store.PERSON_LIABLE[params.index].value
                          },
                          on: {
                            input: (event) => {
                              this.PERSON_LIABLE_store.PERSON_LIABLE[params.index].value = event;
                            }
                          }
                        })]);
                      },
                      key: 'PERSON_LIABLE',
                      value: '',
                      width: 150
                  },
                  {
                      title: this.$t('pdca.t72'),
                      render: (h, params) => {
                        if (this.readOnly) {
                            return h('span', params.row.DEPART_LIABLE);
                        }
                        if (this.DEPART_LIABLE_store.DEPART_LIABLE.length === 0 || this.DEPART_LIABLE_store.DEPART_LIABLE.length === params.index) {
                          this.DEPART_LIABLE_store.DEPART_LIABLE.push({
                            rowIndex: params.index,
                            value: params.row.DEPART_LIABLE
                          });
                        }
                        return h('div', [h('Input', {
                          props: {
                            value: this.DEPART_LIABLE_store.DEPART_LIABLE[params.index].value
                          },
                          on: {
                            input: (event) => {
                              this.DEPART_LIABLE_store.DEPART_LIABLE[params.index].value = event;
                            }
                          }
                        })]);
                      },
                      key: 'DEPART_LIABLE',
                      value: '',
                      width: 150
                  },
                  {
                      title: this.$t('pdca.t73'),
                      align: 'center',
                      width: 60,
                      render: (h, params) => {
                        if (!this.readOnly) {
                            return h('Button', {
                            props: {
                                type: 'text'
                            },
                            style: {
                                  padding: 0
                            },
                            on: {
                              click: () => {
                                this.data.splice(params.index, 1);
                                this.CAUSE_ANALYSIS_store.CAUSE_ANALYSIS.splice(params.index, 1);
                                this.REFORM_MEASURES_store.REFORM_MEASURES.splice(params.index, 1);
                                this.PRO_FIN_DATE_store.PRO_FIN_DATE.splice(params.index, 1);
                                this.PERSON_LIABLE_store.PERSON_LIABLE.splice(params.index, 1);
                                this.DEPART_LIABLE_store.DEPART_LIABLE.splice(params.index, 1);
                              }
                          } }, [h('Icon', {props: {type: 'trash-a'}, style: {fontSize: '24px'}})]);
                        }
                      }
                  }
              ],
              data: [],
              REF_DATA_TYPE1: 'A',
              REF_DATA_TYPE2: 'B'
            };
        },
        watch: {
          '$route' (to, from) {
            if (to.name === 'IncomingProcess') {
              this.reload();
            }
          }
        },
        computed: {
          GSCCPKReportUrl () {
            return `http://${window.environment.isPro ? 'qms.midea.com' : 'qmsuat2.midea.com'}/spc/ExaminedIncomingCpk/GSCCPKReport?id=${this.formData1.WF_NO}&FromExternal=1`;
          },
        orgCode() {
            return this.$route.query.orgCode;
        },
        },
        mounted() {
          this.reload();
          this.getFlowLog();
          this.getProcessTableInfo();
        },
        methods: {
            queryVendorAndMdm (vendorCode) {
                axios.post('/gscint/vendor/queryVendorAndMdm', {
                    vendorCode
                })
                .then((res) => {
                    this.mdmCode = res.data.data.datas.mdmCode;
                });
            },
          rowClassName (row, index) {
            console.log('row', row);
              if (row.currentNode) {
                  return 'table-row';
              }
              return '';
          },
          getProcessTableInfo () {
            axios.get(qmsApiSwitch(this, '/qms2gsc/WorkFlowEx/getProcessTableInfo', this.orgCode), {
              params: {
                fdId: this.fdId,
                userName: this.userName,
                language: this.$i18n.locale
              }
            }).then((res) => {
              let jsonStr = res.data.substring(1).substring(0, res.data.length - 3);
              let data = JSON.parse(jsonStr);
              this.flowTab1Data = JSON.parse(data.Data).MainResultData ? JSON.parse(data.Data).MainResultData : [];
            });
          },
          getFlowLog () {
            axios.get(qmsApiSwitch(this, '/qms2gsc/WorkFlowEx/getFlowLog', this.orgCode), {
              params: {
                fdId: this.fdId,
                userName: this.userName,
                language: this.$i18n.locale
              }
            }).then((res) => {
              let jsonStr = res.data.substring(1).substring(0, res.data.length - 3);
              let data = JSON.parse(jsonStr);
              this.flowData = data.MainResultData ? data.MainResultData : [];
            });
          },
          getVendorId() {
            axios.get('/gscint/vendor/getCurrentVendor', {
              params: {}
            }).then(res => {
              this.vendorCode = res.data.data.vendorCode;
              this.queryVendorAndMdm(this.vendorCode);
            });
          },
          reload () {
            let {type, fdId, userName} = this.$route.query;
            this.type = type;
            this.fdId = fdId;
            this.userName = userName;
            this.getVendorId();
            this.initForm();
          },
          backToPageMain() {
            this.$router.push({name: 'IncomingMaterialInspection'});
          },
          submitProcess() {
            let len = this.data.length;
            let obj = null;
            let dateNow = new Date();
            for (var i = 0; i < len; i++) {
                obj = this.data[i];
                obj.USER_MODIFIED = this.userName;
                obj.DATETIME_MODIFIED = this.dateFormat(dateNow);
                obj.CAUSE_ANALYSIS = this.CAUSE_ANALYSIS_store.CAUSE_ANALYSIS[i].value;
                obj.REFORM_MEASURES = this.REFORM_MEASURES_store.REFORM_MEASURES[i].value;
                obj.PRO_FIN_DATE = this.PRO_FIN_DATE_store.PRO_FIN_DATE[i].value;
                obj.PERSON_LIABLE = this.PERSON_LIABLE_store.PERSON_LIABLE[i].value;
                obj.DEPART_LIABLE = this.DEPART_LIABLE_store.DEPART_LIABLE[i].value;
            }
            let returnObj = {};
            for (let i = 0; i < this.data.length; i++) {
                  if (!this.data[i]['CAUSE_ANALYSIS']) {
                    returnObj.CAUSE_ANALYSIS = this.$t('pdca.t68');
                  }
              if (!this.data[i]['REFORM_MEASURES']) {
                returnObj.REFORM_MEASURES = this.$t('pdca.t69');
              }
              if (!this.data[i]['PRO_FIN_DATE']) {
                returnObj.PRO_FIN_DATE = this.$t('pdca.t70');
              }
              if (!this.data[i]['PERSON_LIABLE']) {
                returnObj.PERSON_LIABLE = this.$t('pdca.t71');
              }
              if (!this.data[i]['DEPART_LIABLE']) {
                returnObj.DEPART_LIABLE = this.$t('pdca.t72');
              }
              }
            let returnList = Object.keys(returnObj).map(key => returnObj[key]);
            if (returnList.length > 0) {
                this.$Modal.error({
                  content: this.$t('pdca.t74') + returnList.join(','),
                });
                return false;
            }

            let reasonAna = {
               ID: this.formData1.PDCA_ID,
               USER_MODIFIED: this.userName,
               DATETIME_MODIFIED: this.dateFormat(dateNow),
               detail: this.data
            };
            axios.post(qmsApiSwitch(this, '/qms2gsc/WorkFlowEx/approveProcessForeign', this.orgCode), {
              fdId: this.fdId,
              language: this.$i18n.locale,
              userName: this.userName,
              operationType: 'handler_pass',
              data: JSON.stringify(reasonAna)
            }).then(res => {
              let jsonStr = res.data.substring(1).substring(0, res.data.length - 3);
              let result = JSON.parse(jsonStr);
              var IsSucess = result.IsSucess;
              if (IsSucess === true) {
                let resultCode = result.MainResultData.resultCode;
                if (resultCode === '010') {
                  this.$Message.success(this.$t('ShipmentInspection.submit_success'));
                  this.backToPageMain();
                } else {
                  this.$Message.error(this.$t('ShipmentInspection.submit_error'));
                }
              } else {
                let ErrorMessage = result.ErrorMessage;
                if (!this.isEmptyValue(ErrorMessage)) {
                  this.$Message.error(ErrorMessage);
                } else {
                  this.$Message.error(this.$t('ShipmentInspection.submit_error'));
                }
              }
            });
          },
          openModalRefuse() {
            this.modalRefuseConfirm = true;
          },
          modalRefuseConfirm_ok() {
            this.fefuseProcess();
          },
          modalRefuseConfirm_cancel() {
          },
          fefuseProcess() {
            axios.post(qmsApiSwitch(this, '/qms2gsc/WorkFlowEx/approveProcessForeign', this.orgCode), {
              fdId: this.fdId,
              language: this.$i18n.locale,
              userName: this.userName,
              operationType: 'handler_refuse',
              data: ''
            }).then(res => {
              let jsonStr = res.data.substring(1).substring(0, res.data.length - 3);
              let result = JSON.parse(jsonStr);
              var IsSucess = result.IsSucess;
              if (IsSucess === true) {
                let resultCode = result.MainResultData.resultCode;
                if (resultCode === '010') {
                  this.$Message.success(this.$t('ShipmentInspection.refuse_success'));
                  this.backToPageMain();
                } else {
                  this.$Message.error(this.$t('ShipmentInspection.refuse_error'));
                }
              } else {
                this.$Message.error(this.$t('ShipmentInspection.refuse_error'));
              }
            });
          },
          initForm() {
            if (this.isEmptyValue(this.fdId) || this.isEmptyValue(this.userName)) {
                this.$Message.error(this.$t('common.repeatPageIn'));
                return;
            }
            this.loading = true;
            axios.get(qmsApiSwitch(this, '/qms2gsc/WorkFlowEx/getInformForeign', this.orgCode), {
              params: {
                fdId: this.fdId,
                userName: this.userName,
                language: this.$i18n.locale
              }
            }).then(res => {
              this.loading = false;
              let jsonStr = res.data.substring(1).substring(0, res.data.length - 3);
              let result = JSON.parse(jsonStr);
              var IsSucess = result.IsSucess;
              if (IsSucess === true) {
                let MainResultData = result.MainResultData;
                console.log('MainResultData.REJECT_COUNT:', MainResultData.REJECT_COUNT);
                this.rejectCount = MainResultData.REJECT_COUNT; // 驳回次数
                // if (this.rejectCount && this.rejectCount >= 1) {
                //   this.$Modal.success({
                //     title: '',
                //     content: `<p style="font-size:16px">请注意PDCA整改报告驳回3次则该编码</br>
                //             停用，并且禁止送货！</br>
                //             目前该报告已驳回${this.rejectCount}次！</p>`,
                //     onOk: () => {
                //       //
                //     }
                //   });
                // }
                this.formData1.ID = this.fdId;
                this.busid = MainResultData.PDCA_ID;
                this.sourceId = MainResultData.SOURCE_ID;
                this.problemSource = MainResultData.PROBLEM_SOURCE;
                this.formData1.PROBLEM_DESC = MainResultData.PROBLEM_DESC;
                this.formData1 = {
                  ...this.formData1,
                  ...MainResultData
                }

                let SubResultData = result.SubResultData;
                let len = SubResultData.length;
                let obj = null;
                this.uploadList1 = [];
                this.uploadList2 = [];
                for (var i = 0; i < len; i++) {
                    obj = SubResultData[i];
                    if (obj.REF_DATA_TYPE === this.REF_DATA_TYPE1) {
                      this.uploadList1.push({
                        name: obj.FILE_NAME,
                        fileId: obj.ID,
                        status: 'finished'
                      });
                    } else if (obj.REF_DATA_TYPE === this.REF_DATA_TYPE2) {
                      this.uploadList2.push({
                        name: obj.FILE_NAME,
                        fileId: obj.ID,
                        status: 'finished'
                      });
                    }
                }

                let DetailResultData = result.DetailResultData;
                len = DetailResultData.length;
                obj = null;
                this.data = [];
                for (i = 0; i < len; i++) {
                  obj = DetailResultData[i];
                  this.data.push({
                    ID: obj.ID,
                    BILL_ID: obj.BILL_ID,
                    USER_MODIFIED: obj.USER_MODIFIED,
                    DATETIME_MODIFIED: obj.DATETIME_MODIFIED,
                    CAUSE_ANALYSIS: obj.CAUSE_ANALYSIS,
                    REFORM_MEASURES: obj.REFORM_MEASURES,
                    PRO_FIN_DATE: obj.PRO_FIN_DATE_TL,
                    PERSON_LIABLE: obj.PERSON_LIABLE,
                    DEPART_LIABLE: obj.DEPART_LIABLE
                  });
                }
                if (len === 0) {
                    this.handleAdd();
                }
              } else {
                this.$Message.error(this.$t('ShipmentInspection.query_error'));
              }
            })
            .catch(() => {
              this.showErrorTips();
            });
          },
          handleBeforeUpload1(file) {
            this.appendFile1 = file;
            return false;
          },
          errorUpload1(error, file, fileList) {
            this.appendFileLoadingStatus1 = false;
            this.$Message.error(this.$t('entBasicInfForm8.upload_error'));
            error = null;
          },
          successUpload1(response, file, fileList) {
            let jsonStr = response.substring(1).substring(0, response.length - 3);
            let result = JSON.parse(jsonStr);
            var IsSucess = result.IsSucess;
            if (IsSucess === true) {
              let MainResultData = result.MainResultData;
              if (!this.isEmptyValue(MainResultData)) {
                this.uploadList1.push({
                  name: this.appendFile1.name,
                  fileId: MainResultData,
                  status: 'finished'
                });
              }
              this.appendFile1 = null;
              this.appendFileLoadingStatus1 = false;
              this.$Message.success(this.$t('entBasicInfForm8.upload_success'));
            } else {
              this.appendFileLoadingStatus1 = false;
              this.$Message.error(this.$t('entBasicInfForm8.upload_error'));
            }
          },
          clickToUpload1() {
            let actionUrl = this.uploadFileUrl + 'busid=' + this.busid + '&ref_data_type=A';
            this.$refs.appendFile_ref1.action = actionUrl;
            this.appendFileLoadingStatus1 = true;
            this.$refs.appendFile_ref1.post(this.appendFile1);
          },
          onFormatErrorUpload1(file, fileList) {
            this.$Message.error(this.$t('ShipmentInspection.upload_FormatError'));
            this.appendFileLoadingStatus1 = false;
          },
          onExceededSizeUpload1(file, fileList) {
            this.$Message.error(this.$t('ShipmentInspection.upload_ExceededSize'));
            this.appendFileLoadingStatus1 = false;
          },
          handleBeforeUpload2(file) {
            this.appendFile2 = file;
            return false;
          },
          errorUpload2(error, file, fileList) {
            this.appendFileLoadingStatus2 = false;
            this.$Message.error(this.$t('entBasicInfForm8.upload_error'));
            error = null;
          },
          successUpload2(response, file, fileList) {
            let jsonStr = response.substring(1).substring(0, response.length - 3);
            let result = JSON.parse(jsonStr);
            var IsSucess = result.IsSucess;
            if (IsSucess === true) {
              let MainResultData = result.MainResultData;
              if (!this.isEmptyValue(MainResultData)) {
                this.uploadList2.push({
                  name: this.appendFile2.name,
                  fileId: MainResultData,
                  status: 'finished'
                });
              }
              this.appendFile2 = null;
              this.appendFileLoadingStatus2 = false;
              this.$Message.success(this.$t('entBasicInfForm8.upload_success'));
            } else {
              this.appendFileLoadingStatus2 = false;
              this.$Message.error(this.$t('entBasicInfForm8.upload_error'));
            }
          },
          clickToUpload2() {
            let actionUrl = this.uploadFileUrl + 'busid=' + this.busid + '&ref_data_type=B';
            this.$refs.appendFile_ref2.action = actionUrl;
            this.appendFileLoadingStatus2 = true;
            this.$refs.appendFile_ref2.post(this.appendFile2);
          },
          onFormatErrorUpload2(file, fileList) {
            this.$Message.error(this.$t('ShipmentInspection.upload_FormatError'));
            this.appendFileLoadingStatus2 = false;
          },
          onExceededSizeUpload2(file, fileList) {
            this.$Message.error(this.$t('ShipmentInspection.upload_ExceededSize'));
            this.appendFileLoadingStatus2 = false;
          },
          downloadUploadListFile(fileId) {
            window.open(this.downloadUploadListFileUrl + fileId);
          },
          handleAdd() {
              this.data.push({
                ID: '',
                BILL_ID: this.formData1.PDCA_ID,
                USER_MODIFIED: this.userName,
                DATETIME_MODIFIED: '',
                CAUSE_ANALYSIS: '',
                REFORM_MEASURES: '',
                PRO_FIN_DATE: '',
                PERSON_LIABLE: '',
                DEPART_LIABLE: ''
            });
          },
          isEmptyValue(value) {
            if (value === null || value === 'null' || value === undefined || value === 'undefined' || value === '') {
              return true;
            }
            return false;
          },
          /* yyyy-MM-dd HH:mm:ss */
          dateFormat(value) {
            try {
              return value.getFullYear() + '-' + (((value.getMonth() + 1) < 10) ? '0' + (value.getMonth() + 1) : (value.getMonth() + 1)) + '-' + ((value.getDate() < 10) ? '0' + value.getDate() : value.getDate()) + ' ' + ((value.getHours() < 10) ? '0' + value.getHours() : value.getHours()) + ':' + ((value.getMinutes() < 10) ? '0' + value.getMinutes() : value.getMinutes()) + ':' + ((value.getSeconds() < 10) ? '0' + value.getSeconds() : value.getSeconds());
            } catch (err) {
              if (value === undefined || value === 'undefined' || value === null || value === 'null') {
                return '';
              } else {
                return value;
              }
            }
          },
          /* yyyy-MM-dd */
          dateFormat2(value) {
            try {
              return value.getFullYear() + '-' + (((value.getMonth() + 1) < 10) ? '0' + (value.getMonth() + 1) : (value.getMonth() + 1)) + '-' + ((value.getDate() < 10) ? '0' + value.getDate() : value.getDate());
            } catch (err) {
              if (value === undefined || value === 'undefined' || value === null || value === 'null') {
                return '';
              } else {
                return value;
              }
            }
          },
          viewShipmentInspection() {
            if (this.isEmptyValue(this.problemSource)) {
              this.$Message.error(this.$t('viewPdca.t51'));
              return;
            }
            if (this.isEmptyValue(this.sourceId) || this.problemSource !== 'Verify') {
              this.$Message.error(this.$t('viewPdca.t52'));
              return;
            }
            this.$router.push({
              name: 'viewShipmentInspection',
              query: {
                sourceId: this.sourceId,
                language: this.$i18n.locale
              }
            });
          },
          format(file) {
              const format = file.name.split('.').pop().toLocaleLowerCase() || '';
              let type = 'document';
              if (['gif', 'jpg', 'jpeg', 'png', 'bmp', 'webp'].indexOf(format) > -1) {
                  type = 'image';
              }
              if (['mp4', 'm3u8', 'rmvb', 'avi', 'swf', '3gp', 'mkv', 'flv'].indexOf(format) > -1) {
                  type = 'ios-film';
              }
              if (['mp3', 'wav', 'wma', 'ogg', 'aac', 'flac'].indexOf(format) > -1) {
                  type = 'ios-musical-notes';
              }
              if (['doc', 'txt', 'docx', 'pages', 'epub', 'pdf'].indexOf(format) > -1) {
                  type = 'document-text';
              }
              if (['numbers', 'csv', 'xls', 'xlsx'].indexOf(format) > -1) {
                  type = 'stats-bars';
              }
              if (['keynote', 'ppt', 'pptx'].indexOf(format) > -1) {
                  type = 'ios-videocam';
              }
              return type;
          },
          deleteUploadListFile(uploadListIndex, fileId) {
            axios.post('/qms2gsc/file/delete' + '?id=' + fileId + '&deletefile=Y', {
            }).then(res => {
              let jsonStr = res.data.substring(1).substring(0, res.data.length - 3);
              let result = JSON.parse(jsonStr);
              var IsSucess = result.IsSucess;
              if (IsSucess === true) {
                let len = 0;
                let obj = null;
                if (uploadListIndex === '1') {
                  len = this.uploadList1.length;
                  for (var i1 = 0; i1 < len; i1++) {
                      obj = this.uploadList1[i1];
                      if (obj.fileId === fileId) {
                        this.uploadList1.splice(i1, 1);
                        break;
                      }
                  }
                } else if (uploadListIndex === '2') {
                  len = this.uploadList2.length;
                  obj = null;
                  for (var i2 = 0; i2 < len; i2++) {
                    obj = this.uploadList2[i2];
                    if (obj.fileId === fileId) {
                      this.uploadList2.splice(i2, 1);
                      break;
                    }
                  }
                }
                this.$Message.success(this.$t('ShipmentInspection.delete_success'));
              } else {
                this.$Message.error(this.$t('ShipmentInspection.delete_error'));
              }
            }).catch(() => {
              this.$Modal.error({
                title: this.$t('common.warn'),
                content: this.$t('common.error1')
              });
            });
          },
          badItemHistoryClick() {
            this.formDataBadItem.items[0].value = this.formData1.MATERIAL_CODE;
            this.formDataBadItem.items[2].value = this.formData1.MATERIAL_DESC;
            let now = new Date();
            let subMonth = (now.getMonth() + 1) - 6;
            let subYear = now.getFullYear();
            if (subMonth <= 0) {
              subYear = now.getFullYear() - 1;
              subMonth = subMonth + 12;
            }
            subMonth = ((subMonth < 10) ? '0' + subMonth : subMonth);
            let date1 = subYear + '-' + subMonth + '-01';
            let date2 = now;
            let dateRange = [];
            dateRange.push(date1);
            dateRange.push(this.dateFormat2(date2));
            this.formDataBadItem.items[1].value = dateRange;
            this.modal1 = true;
            this.condition = {
              itemCode: this.formDataBadItem.items[0].value,
              startEndCheckDate: dateRange[0] + ',' + dateRange[1]
            };
            this.onSubmitBadItem(this.current, this.pageSize, this.condition);
          },
          onSubmitBadItem(pageIndex, pageSize, condition) {
            console.log(this.formData1, this.formData1.ORG_ID);
            this.dataBadItem = [];
            this.current = pageIndex;
            this.pageSize = pageSize;
            this.condition = condition;
            this.loading = true;

            var itemCode = condition.itemCode;
            if (itemCode === undefined) {
                itemCode = '';
            }
            var checkedDateBegin = '';
            var checkedDateEnd = '';
            var startEndCheckDate = condition.startEndCheckDate;
            if (startEndCheckDate !== undefined && startEndCheckDate !== '' && startEndCheckDate !== ',') {
              var startEndCheckDateArr = startEndCheckDate.split(',');
              checkedDateBegin = startEndCheckDateArr[0];
              checkedDateEnd = startEndCheckDateArr[1];
            }
            axios.get(qmsApiSwitch(this, '/qms2gsc/IqcOutgoing/queryNgListForeign', this.orgCode), {
              params: {
                pageIndex,
                pageSize,
                orgId: this.formData1.ORG_ID,
                itemCode,
                checkedDateBegin,
                checkedDateEnd,
                supplierCode: this.mdmCode,
                language: this.$i18n.locale
              }
            }).then(res => {
              let jsonStr = res.data.substring(1).substring(0, res.data.length - 3);
              let result = JSON.parse(jsonStr);
              var IsSucess = result.IsSucess;
              if (IsSucess === true) {
                let MainResultData = result.MainResultData.DATA;
                if (!this.isEmptyValue(MainResultData)) {
                  let len = MainResultData.length;
                  let obj = null;
                  for (var i = 0; i < len; i++) {
                    obj = MainResultData[i];
                    this.dataBadItem.push({
                      vendorCode: obj.SUPPLIER_CODE,
                      number: obj.BARCODE_NUMBER,
                      type1: obj.BIG_CLASS,
                      type2: obj.MID_CLASS,
                      type3: obj.SMALL_CLASS,
                      date: obj.CHECKED_DATE,
                      content: obj.NG_INFO
                    });
                  }
                  this.total = result.MainResultData.TOTAL;
                } else {
                  this.total = 0;
                }
              } else {
                this.$Modal.error({
                  title: this.$t('common.warn'),
                  content: this.$t('ShipmentInspection.query_error')});
              }
              this.loading = false;
            });
          },
          ok() {
          },
          cancel() {
          },
          /* 页容量改变时触发 */
          onPageSizeChange(page, pageSize, condition) {
            this.onSubmitBadItem(page, pageSize, condition);
          },
          /* 当前页改变时触发 */
          onCurrentPageChange(page, pageSize, condition) {
            this.onSubmitBadItem(page, pageSize, condition);
          }
        }
    };
</script>
<style lang="less" scoped>
  .m-form-item {
    margin-bottom: 0px;
    vertical-align: top;
    zoom: 1;
  }
    .upload-list{
        margin-top: 8px;

        &-file{
            padding: 10px 4px;
            width: 250px;
            color: #333;
            border-radius: 2px;
            overflow: hidden;
            position: relative;
            background: #fff;
            margin-bottom: 10px;
            box-shadow: 0 1px 6px rgba(0,0,0,.2);
            &:last-child {
                margin-bottom: 0;
            }
            & > span{
                cursor: pointer;
                display: inline-block;
                height: 24px;
                vertical-align: middle;
                span {
                    line-height: 24px;
                    height: 24px;
                    display: inline-block;
                }
                i{
                    float: left;
                    display: inline-block;
                    font-size: 24px;
                    width: 24px;
                    height: 24px;
                    color: #333;
                    text-align: center;
                    margin-right: 5px;
                }
            }
            &:hover{
                background: #ccc;
                & > span{
                    color: #007AFF;
                    i{
                        color: #999;
                    }
                }
                .upload-list-remove{
                    opacity: 1;
                }
            }
        }
        &-remove{
            opacity: 0;
            font-size: 18px;
            cursor: pointer;
            float: right;
            margin-right: 4px;
            color: #333;
            &:hover{
                color: #444;
            }
        }
    }
    .title-bar {
        background-color: #F2F2F2;
        border: 1px solid #dddee1;
        padding: 10px 20px;
        button {
            float: right;
        }
        span {
            border-left: 5px solid #3AA2EB;
            padding: 0 7px;
            font-size: 15px;
            font-weight: 400;
            height: 32px;
            line-height: 32px;
        }
    }

    .form-table {
        width: 100%;
        table-layout: fixed;
        background: #FFF;
        th {
            background-color: #FFF;
        }
        th,
        td {
            height: 40px;
            line-height: 40px;
            border-bottom: 1px solid #e9eaec;
            border-right: 1px solid #e9eaec;
            padding: 0 5px;
        }
        td {
            text-align: center;
            background-color: #fff;
        }
        .ellipsis {
            overflow: hidden;
            text-overflow: ellipsis;
            word-break: break-all;
            box-sizing: border-box;
            word-break: keep-all;
            white-space: nowrap;
            overflow: hidden;
        }
    }

    @css-prefix: ivu-;
    @table-prefix-cls: ~"@{css-prefix}table";
    @table-select-item-prefix-cls: ~"@{table-prefix-cls}-filter-select-item";
    @border-color-base: #dddee1;
    @text-color: #495060;
    @font-size-base: 14px;
    @font-size-small: 12px;
    @border-color-split: #e9eaec;
    @head-bg: #f9fafc;
    @table-thead-bg: #f8f8f9;
    @table-td-stripe-bg: #f8f8f9;
    @table-td-hover-bg: #ebf7ff;
    @table-td-highlight-bg: #ebf7ff;
    @animation-time: .3s;
    @transition-time: .2s;
    @ease-in-out: ease-in-out;
    @shadow-color: rgba(0, 0, 0, .2);
    @shadow-base: @shadow-down;
    @shadow-card: 0 1px 1px 0 rgba(0, 0, 0, .1);
    @shadow-up: 0 -1px 6px @shadow-color;
    @shadow-down: 0 1px 6px @shadow-color;
    @shadow-left: -1px 0 6px @shadow-color;
    @shadow-right: 1px 0 6px @shadow-color;
    .layout {
        padding: 10px;
    }

    .wrapper {
        background: #FFF;
    }

    .@{table-prefix-cls} {
        &-wrapper {
            position: relative;
            border: 1px solid @border-color-base;
            border-bottom: 0;
            border-right: 0;
        }
        width: inherit;
        height: 100%;
        max-width: 100%;
        overflow: hidden;
        color: @text-color;
        font-size: @font-size-small;
        background-color: #fff;
        box-sizing: border-box;
        &-hide {
            opacity: 0;
        }
        &:before {
            content: '';
            width: 100%;
            height: 1px;
            position: absolute;
            left: 0;
            bottom: 0;
            background-color: @border-color-base;
            z-index: 1;
        }
        &:after {
            content: '';
            width: 1px;
            height: 100%;
            position: absolute;
            top: 0;
            right: 0;
            background-color: @border-color-base;
            z-index: 3;
        }
        &-header {
            overflow: hidden;
        }
        &-body {
            overflow: auto;
        }
        th,
        td {
            min-width: 0;
            height: 48px;
            box-sizing: border-box;
            text-align: left;
            text-overflow: ellipsis;
            vertical-align: middle;
            border-bottom: 1px solid @border-color-split;
        }
        th {
            height: 40px;
            white-space: nowrap;
            overflow: hidden;
            background-color: @table-thead-bg;
            &.table-info-cell-name {
                background-color: #FFFF99;
            }
        }
        td {
            background-color: #fff;
            transition: background-color @transition-time @ease-in-out;
        }
        th&-column,
        td&-column {
            &-left {
                text-align: left;
            }
            &-center {
                text-align: center;
            }
            &-right {
                text-align: right;
            }
        }
        & table {
            table-layout: fixed;
        }
        &-border {
            th,
            td {
                border-right: 1px solid @border-color-split;
            }
        }
        &-cell {
            padding-left: 10px;
            padding-right: 10px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: normal;
            word-break: break-all;
            box-sizing: border-box;
            &-ellipsis {
                word-break: keep-all;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
            &-with-expand {
                height: 47px;
                line-height: 47px;
                padding: 0;
                text-align: center;
            }
            &-expand {
                cursor: pointer;
                transition: transform @transition-time @ease-in-out;
                i {
                    font-size: @font-size-base;
                }
                &-expanded {
                    transform: rotate(90deg);
                }
            }
        }
        &-hidden {
            visibility: hidden;
        }
        th &-cell {
            display: inline-block;
            word-wrap: normal;
            vertical-align: middle;
        }
        td&-expanded-cell {
            padding: 20px 50px;
            background: @table-thead-bg;
        }
        tr&-row-hover {
            td {
                background-color: @table-td-hover-bg;
            }
        }
        &-stripe &-body,
        &-stripe &-fixed-body {
            tbody:nth-child(2n+1) {
                td {
                    background-color: @table-td-stripe-bg;
                }
            }
        }
        .ivu-table-overflowX {
            overflow-x: scroll;
        }
        .ivu-table-overflowY {
            overflow-y: scroll;
        }
    }
    .pdca-table {
        td {
            padding: 0 5px;
        }
    }
</style>
<style lang="less">
  .IncomingProcessTable .table-row {
    td {
      background: #FED6D6;
    }
  }
</style>
